import React from 'react'
// hooks
import { useModalData } from 'hooks/index'
// components
import { Button, BUTTON_LAYOUTS, Modal } from 'components/UI'
// views
import { Text, Header, ButtonContainer } from './views'
// constants
import { Modals } from 'constants/modals'

const RiskConfirmModal: React.FC = () => {
  const {
    hideModal,
    modalData: { isOpen, width, text, title, resolve }
  } = useModalData({ modalType: Modals.RISK_CONFIRM_MODAL })

  const onConfirmClick = () => {
    resolve(true)
    hideModal()
  }

  const onCancelClick = () => {
    resolve(false)
    hideModal()
  }

  if (!isOpen) {
    return null
  }

  return (
    <Modal hideModal={onCancelClick} isOpen={isOpen} width={width} PaperProps={{ style: { width: '554px' } }}>
      <Header handleClearClick={onCancelClick}>{title}</Header>
      <Text>{text}</Text>
      <ButtonContainer>
        <Button layout={BUTTON_LAYOUTS.RED} onClick={onConfirmClick}>
          Confirm
        </Button>
        <Button layout={BUTTON_LAYOUTS.RED_INVERTED} onClick={onCancelClick}>
          Cancel
        </Button>
      </ButtonContainer>
    </Modal>
  )
}

export default RiskConfirmModal
